import { DayPicker as DefaultDayPicker } from 'react-day-picker';

import { de } from 'react-day-picker/locale';

export const datePickerLocale = de;
export const DatePicker = DefaultDayPicker;

export default DatePicker;
